import { REQUEST_BOARD_FULL_RELOAD_ACTIONS } from './useRequestBoardItemReload.constants'

function isRequestBoardItemScopedAction(actedItem) {
  return (
    Boolean(actedItem) &&
    !REQUEST_BOARD_FULL_RELOAD_ACTIONS.includes(actedItem.action)
  )
}

export function getRequestBoardReloadItemId({ actedItem, mutatedItemId }) {
  return (
    mutatedItemId ??
    (isRequestBoardItemScopedAction(actedItem) ? actedItem.id : null)
  )
}
